import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';

function NewFaq(props: BaseMsgProps) {
  const { newFaqContent } = props.raw;

  if (!newFaqContent) {
    return <></>;
  }

  const { opening, categories } = newFaqContent;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <Container>
          <div>{opening}</div>
          <ul>
            {categories.map(({ title }) => (
              <li>{title}</li>
            ))}
          </ul>
        </Container>
      }
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  border-radius: 4px;
  background: #fff;
  > div {
    padding: 8px 12px;
    border-bottom: solid 1px #f0f2f5;
  }
  > ul {
    margin: 0;
    padding: 0 12px;
    list-style: none;
    > li {
      padding: 8px 0;
      color: #84868c;
      & + li {
        border-top: solid 1px #f0f2f5;
      }
    }
  }
`;

export default NewFaq;
